export const htmlAttributes = {
  ARIA_CHECKED: 'aria-checked',
  ARIA_LABEL: 'aria-label',
  ARIA_SELECTED: 'aria-selected',
  CLASS: 'class',
  DATA_AT_ACTIVE: 'data-at-active',
  DATA_AT_AGGREGATED_STATUS: 'data-at-aggregated-status',
  DATA_AT_ANOMALY_DATE: 'data-at-anomaly-date',
  DATA_AT_ANOMALY_DESCRIPTION: 'data-at-anomaly-description',
  DATA_AT_ANOMALY_GROUP: 'data-at-anomaly-group',
  DATA_AT_ANOMALY_ID: 'data-at-active-anomaly-id',
  DATA_AT_ANOMALY_PRIORITY: 'data-at-anomaly-priority',
  DATA_AT_ANOMALY_RECOMMENDATION: 'data-at-anomaly-recommendation',
  DATA_AT_BLUR: 'data-at-blur',
  DATA_AT_BOOKING_INSTALLATION_ID: 'data-at-installation-id',
  DATA_AT_CHECKED: 'data-at-checked',
  DATA_AT_CONNECTION_REASON: 'data-at-connection-reason-dropdown-option',
  DATA_AT_CONNECTION_STATUS: 'data-at-connection-status',
  DATA_AT_DISABLED: 'data-at-disabled',
  DATA_AT_EDIT_VALUE: 'data-at-remote-diagnostics-edit-value',
  DATA_AT_INSTALLATION_DETAILS_INSTALLATION_ID: 'data-at-installation-details-installationId',
  DATA_AT_SUBMENU_OPTION: 'data-at-submenu-option',
  DATA_AT_SUBSCRIPTION: 'data-at-subscription',
  DATA_AT_VENTILATION_BYPASS_MODE: 'data-at-bypass-mode',
  DATA_AT_VENTILATION_BYPASS_STATE: 'data-at-ventilation-bypass-state',
  DATA_AT_VENTILATION_OPERATING_MODE: 'data-at-ventilation-operating-mode',
  DATA_AT_VENTILATION_OPERATING_PROGRAM: 'data-at-ventilation-operating-program',
  DATA_AT_DHW_RUST_SURVEILLANCE_CURRENT_VALUE: 'data-at-dhw-rust-surveillance-current-value',
  DATA_AT_DHW_RUST_SURVEILLANCE_CURRENT_UNIT: 'data-at-dhw-rust-surveillance-current-unit',
  DATA_AT_PRIMARY_CIRCUIT_AIR_SOURCE: 'data-at-primary-circuit-air-source',
  DATA_AT_SPACE_FROST_PROTECTION: 'data-at-space-frost-protection',
  DATA_AT_PV_SIGNAL_ACTIVE: 'data-at-device-pvSignal-active',
  DATA_AT_MENU_ITEM: 'data-at-menu-item',
  DATA_AT_SETTINGS: 'data-at-settings',
  DATA_AT_KANBAN_BOARD: 'data-at-kanban-board',
  DATA_AT_FIRST_UNIT: 'data-at-first-unit',
  DATA_AT_UNIT_SETTINGS: 'data-at-units-setting',
  DATA_AT_SPACE_FROST_PROTECTION_DROPDOWN: 'data-at-space-frost-protection-dropdown',
  DATA_AT_OPTION: 'data-at-option',
  DATA_AT_MESSAGE_TYPE: 'data-at-message-type',
  DATA_AT_BOOKING_OVERLAY: 'data-at-booking-overlay',
  DATA_AT_BASIC_CONTENT: 'data-at-basic-content',
  DATA_AT_PRO_CONTENT: 'data-at-pro-content',
  DATA_AT_PACKAGE_CONTENT_ROW: 'data-at-package-content-row',
  DATA_AT_PACKAGE_CONTENT_TITLE: 'data-at-package-content-title',
  DATA_AT_PACKAGE_CONTENT_ICON: 'data-at-package-content-icon',
  DATA_AT_PACKAGE_CONTENT_TOOLTIP_ICON: 'data-at-package-content-tooltip-icon',
  DATA_AT_MONTHLY_PRICE: 'data-at-monthly-price',
  DATA_AT_ANNUAL_PRICE: 'data-at-annual-price',
  DATA_AT_REMAINING_DEVICES: 'data-at-remaining-devices',
  DATA_AT_BUY_PRO_BUTTON: 'data-at-buy-Pro-button',
  DATA_AT_BUY_TRIAL_BUTTON: 'data-at-buy-Trial-button',
  DATA_AT_PRICE_INFO_ICON: 'data-at-price-info-icon',
  DATA_AT_TEST_PLAN_INFO_ICON: 'data-at-test-plan-info-icon',
  DATA_AT_PLUS_SECTION: 'data-at-plus-section',
  DATA_AT_PLUS_PRICE: 'data-at-plus-price',
  DATA_AT_BUY_PLUS_BUTTON: 'data-at-buy-Plus-button',
  DATA_AT_PRO_PLUS_SECTION: 'data-at-pro-plus-section',
  DATA_AT_PACKAGE_PRICE: 'data-at-package-price',
  DATA_AT_BOOKING_ROW_TOOLTIP: 'data-at-feature-description',
  DATA_AT_PRICE_INFO: 'data-at-price-info',
  DATA_AT_TEST_PLAN_CONDITIONS: 'data-at-test-plan-conditions',
  DATA_AT_DEVICES_COUNTER: 'data-at-devices-counter',
  DATA_AT_SELECTED_PACKAGE: 'data-at-selected-package',
  DATA_AT_SELECTED_DEVICES_AMOUNT: 'data-at-selected-devices-amount',
  DATA_AT_SUBSCRIBED_PACKAGE: 'data-at-subscribed-package',
  DATA_AT_BOOKED_PACKAGE: 'data-at-booked-package',
  DATA_AT_BMU_STATUS: 'data-at-bmu-status',
  DATA_AT_VENTILATION_DIAGNOSTIC_INFO: 'data-at-diagnostic-info',
  DATA_AT_VALUE: 'data-at-value',
  DATA_AT_REFRIGERANT_CIRCUIT_PANEL_FEATURE: 'data-at-refrigerant-circuit-panel-feature',
  DATA_AT_OPTION_TIME: 'data-at-option-time',
  DATA_AT_PROGRAM_MODE: 'data-at-program-mode',
  DATA_AT_PROGRAM_START: 'data-at-program-start',

  DISABLED: 'disabled',
  ID: 'id',
  MAX: 'max',
  MAX_LENGTH: 'maxlength',
  MIN: 'min',
  STEP: 'step',
  TEXT: 'textContent',
};

export enum dateFormats {
  DD_MM_YYYY_HH_MM_SS = 'DD/MM/YYYY, HH:mm:ss',
  DD_MM_YYYY_DASH = 'DD-MM-YYYY',
  DD_MM_YYYY_SLASH = 'DD/MM/YYYY',
  HH_MM = 'hh:mm',
  H_MM_A = 'h:mm A',
  MM = 'MM',
  MMM_D_YYYY = 'MMM D, YYYY',
  MM_YYYY = 'MM/YYYY',
  M_D_YY_SLASH = 'M/D/YY',
  M_D_YY_H_MM_SLASH = 'M/D/YY, h:mm A',
  MM_DD_YYYY_SLASH = 'MM/DD/YYYY',
  YYYY = 'YYYY',
  YYYY_MM_DD_DASH = 'YYYY-MM-DD',
  YYYY_MM_DD_SLASH = 'YYYY/MM/DD',
}

export const pages = {
  BOOKING_OVERVIEW: 'Booking Overview',
  HOME_PAGE: 'Home Page',
  INSTALLATIONS_OVERVIEW: 'Overview',
  INSTALLATIONS_OVERVIEW_NO_DATA: 'Overview no data',
  INSTALLATION_DETAILS: 'Installation details',
  RSA_SEARCH: 'Search',
  SMART_ROOM_CONTROL: 'Smart Room Control',
  SETTINGS: 'Settings',
};

export const stepWording = {
  ACTIVATE: 'activate',
  ACTIVE: 'active',
  ALL: 'all',
  DATE: 'date',
  DEACTIVATE: 'deactivate',
  DHW: 'DHW',
  ERROR: 'error',
  FALSE: 'false',
  GATEWAY: 'gateway',
  MAIN: 'main',
  MAINTAINER: 'maintainer',
  NEW: 'new',
  NEXT: 'next',
  NO: 'no',
  NO_EDITABLE_FIELD: 'lack of editable field',
  NOK: 'nok',
  NO_VALUE: 'no value',
  NOT_UPDATED: 'not updated',
  OFF: 'off',
  OFFLINE: 'Offline',
  OK: 'ok',
  ON: 'on',
  ONLINE: 'Online',
  OVERLAY: 'overlay',
  PREVIOUS: 'previous',
  RANDOM: 'random',
  ROOM_CONTROL_1: 'RoomControl-1',
  RSA: 'rsa',
  SELECTED: 'selected',
  STATUS: 'status',
  TILE: 'tile',
  TRUE: 'true',
  UNKNOWN: 'unknown',
  UPDATED: 'updated',
  VITO: 'Vito',
  VITOCAL: 'Vitocal',
};

export const timeouts = {
  MS_500: 500,
  REMOTE_DIAGNOSTICS_VDD: 100000000,
  S_1: 1000,
  S_10: 10000,
  S_120: 120000,
  S_15: 15000,
  S_25: 25000,
  S_2: 2000,
  S_3: 3000,
  S_30: 30000,
  S_20: 20000,
  S_40: 40000,
  S_60: 60000,
  S_5: 5000,
};

export const separators = {
  AMPERSAND: '&',
  COLON: ':',
  COMMA: ',',
  DASH: '-',
  DOT: '.',
  EMPTY_STRING: '',
  HASH: '#',
  QUESTION_MARK: '?',
  SLASH: '/',
  SPACE: ' ',
};

export const deviceNames = {
  CLIMATE_SENSOR: 'ViCare Climate Sensor',
  ETRV: 'ViCare Radiator Valve',
  FHT: 'ViCare Floor Thermostat',
  GATEWAY: '0',
};

export const installationStatusIcons = {
  ACTIVE_ERRORS: 'error',
  MAINTENANCE: 'maintenance',
  OFFLINE: 'wifi_off',
  WORKING: 'check_circle',
  LOCKED_SYSTEM: 'cancel',
};

export enum AggregatedStatuses {
  ActiveErrors = 'error',
  Maintenance = 'maintenance',
  Offline = 'offline',
  Working = 'working',
  LockedSystem = 'coldSystem',
  RemoteDiagnostics = 'remoteDiagnostic',
}

export const patterns = {
  ANY_LETTER_OR_WHITESPACE: '[a-zA-Z0-9 ]',
  ANY_LETTER: '[a-zA-Z]',
  DATE_HH_MM: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
};

export enum timeValues {
  DayOfMonth = 'Day of month',
  Month = 'Month',
  Year = 'Year',
}
export const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export const remoteDiagnostics = {
  CHECK: 'check',
  CLOSE: 'close',
  CONNECTED: 'connected',
  CONNECTION_STATUSES: {
    ACTIVE: 'ACTIVE',
    FAILED: 'FAILED',
    INACTIVE: 'INACTIVE',
    LOADING: 'LOADING',
  },
  CONTROL_UNITS: {
    BCU: 'LL_0001_BCU_CAN50',
    HMI: 'LL_0003_HMI_CAN59',
    HMU: 'LL_0002_HMU_CAN01',
    WIFI: 'LL_0010_WiFi_CAN58',
  },
  DESCRIPTION: 'description',
  DISCONNECTED: 'disconnected',
  EDITABLE_SEMANTICS: [
    'ACTUATORVALUE',
    'ENTRIES',
    'ENUM',
    'ENUMCHOICE',
    'BOOLEANCHOICE',
    'BOOLEAN',
    'VALUEWRITE',
    'VALUE',
    'HEATINGCURVEGRADIENT',
    'HEATINGCURVELEVEL',
    'DEFLEVEL',
    'LOWLOWLEVEL',
    'LOWLEVEL',
    'HIGHHIGHLEVEL',
    'HIGHLEVEL',
    'SECOND',
    'DAY',
    'MONTH',
    'YEAR',
  ],
  GTS: 'guidedTroubleshooting',
  HYDRAULIC_SCHEME_TYPES: {
    INTERNAL: 'internal',
    SYSTEM: 'system',
  },
  TIME_SEMANTICS: ['DAY', 'MONTH', 'YEAR'],
  EDITABLE_VALUE_TYPES: {
    DATE: 'date',
    ENUM: 'enum',
    NUMBER: 'number',
    TEXT: 'text',
  },
  JSON_KEY: {
    PATH: 'path',
  },
  MAC_ADDRESS: 'MAC',
  METADATA: 'Metadata',
  METADATAS: 'metadatas',
  MODIFIABLE: 'Modifiable',
  MODIFIABLE_FALSE: 'Modifiable: False',
  MODIFIABLE_TRUE: 'Modifiable: True',
  REPORT: {
    CHART_DISPLAYED: 'Chart is displayed',
    CHART_ELEMENTS_DISPLAYED: 'Values and tooltip are displayed',
    CHART_NOT_DISPLAYED: 'Chart is not displayed',
    CHART_SHOULD_NOT_BE_DISPLAYED: 'Chart should NOT be displayed',
    DATE_PARAM: 'date parameter',
    DESCRIPTION_MISSING: 'description missing',
    EMPTY_TRANSLATION_ID: 'empty translation id',
    LACK_OF_VALUE: 'lack of value',
    MISSING_TRANSLATION: 'missing translation',
    NO_TRANSLATION_ID: 'lack of translation id',
    NEW_VDD: 'new Vdd',
    NOT_A_SENSOR: 'notSensor',
    NO_VDD_ERROR: 'vdd not available or parameter cannot be displayed',
    NO_VALUE: 'lack of value',
    NO_VALUE_TO_EDIT: 'no value to edit',
    PA_DATA_RECOR: 'PA_DataRecor/PA_Value',
    PARAMETER_ERROR: 'Parameter cannot be displayed',
    PA_STRUC: 'PA_Struc/PA_Value',
    VDD_NOT_AVAILABLE: 'Vdd not available',
    VERSION: 'Version',
  },
  REPORT_TYPE: {
    CHART: 'chart',
    EDITING_PARAMETERS: 'Editable values verification',
    METADATA_STRUCTURE: 'Metadata and structure verification',
  },
  SEMANTIC: 'semantic',
  SEMANTIC_TYPE: {
    ENUM: ['ENUMCHOICE', 'ENUM', 'BOOLEANCHOICE', 'BOOLEAN'],
    RESERVED: 'RESERVED',
    SENSOR_VALUE: 'SENSORVALUE',
    SERVICE_ID: 'SERVICE-ID',
    VERSION_VALUE: 'VERSIONVALUE',
  },
  SENSOR: 'Sensor',
  NOT_TOUCH_VDD: [
    '573',
    '574',
    '602',
    '603',
    '604',
    '607',
    '616',
    '618',
    '619',
    '1467',
    '952',
    '1549',
  ],
  STRUCTURE: 'structure',
  TRANSLATION_ID: 'translationid',
  UNIT: 'unit',
  VALUE: 'value',
};
export enum units {
  MA = 'mA',
  Celsius = '°C',
  Fahrenheit = '°F',
  KiloWatHours = 'kWh',
}

export const scrollPositions = {
  CENTER: 'center',
  END: 'end',
  NEAREST: 'nearest',
  START: 'start',
};

export const reportColors = {
  ANTIQUEWHITE: 'antiquewhite',
  CORAL: 'coral',
  DARKSALMON: 'darksalmon',
  FORESTGREEN: 'forestgreen',
  HONEYDEW: 'honeydew',
  LIGHTGREEN: 'lightgreen',
  PAPAYAWHIP: 'papayawhip',
  PEACHPUFF: 'peachpuff',
};

export const fileTypes = {
  HTML: 'html',
};

export const eventTypesForRequest = {
  ADDRESS_CHANGE: 'installation-address-changed',
  BMU_SERIAL_CHANGE: 'device-bmu-serial-changed',
  BOILER_SERIAL_NUMBER_CHANGE: 'device-boiler-serial-changed',
  DEVICE_ERRORS:
    'device-error&eventType=device-message-info&eventType=device-message-service&eventType=device-message-warning',
  FEATURE_CHANGE: 'feature-changed',
  FIRMWARE_UPDATE: 'firmware-update-status',
  GATEWAY_RESET: 'gateway-reset-command',
  GATEWAY_STATUS_CHANGE: 'gateway-online',
  GEOFENCING_STATUS_CHANGE: 'geofencing-activation-changed',
  INVITATION_ACCEPTED: 'invitation-accepted',
  INVITATIONS_TERMINATED: 'invitation-terminated',
  SRC_STATUS_CHANGE: 'src-status-changed',
};

export const eventTypes = {
  ADDRESS_CHANGE: 'Address change',
  BMU_SERIAL_CHANGE: 'BMU serial change',
  BOILER_SERIAL_NUMBER_CHANGE: 'Boiler serial number change',
  DEVICE_ERRORS: 'Device errors',
  FEATURE_CHANGE: 'Feature change',
  FIRMWARE_UPDATE: 'Firmware update',
  GATEWAY_RESET: 'Communication module reset',
  GATEWAY_STATUS_CHANGE: 'Communication module status change',
  GEOFENCING_STATUS_CHANGE: 'Geofencing status change',
  INVITATION_ACCEPTED: 'Invitation accepted',
  INVITATIONS_TERMINATED: 'Invitation terminated',
  SRC_STATUS_CHANGE: 'Status change ViCare Smart Climate',
};

export const monetization = {
  FILTERS: {
    ALL: 'all',
    PLUS: 'plus',
    PRO: 'pro',
    TRIAL: 'trial',
  },
  PACKAGE_TYPES: {
    BASIC: 'Basic',
    PLUS: 'Plus',
    PRO: 'Pro',
    TRIAL: 'Trial',
  },
  STATUSES: {
    ACTIVE: 'Active',
    CANCELLED: 'Cancelled',
    EXPIRED: 'Expired',
  },
  TRIAL_DURATION: '28',
};

export const snackBarTypes = {
  ERROR: 'error',
  INFO: 'info',
};

export const heatingOperatingModes = {
  DHW: {
    DHW: 'dhw',
    DHW_AND_COOLING: 'dhwAndCooling',
    DHW_AND_HEATING: 'dhwAndHeating',
    DHW_AUTO: 'dhwAndAuto',
    DHW_HEATING_COOLING: 'dhwAndHeatingCooling',
  },
  HEATING: 'heating',
  STANDBY: 'standby',
};

export const dhwPrograms = {
  ON: ['top', 'on', 'temp-2', 'normal'],
  OFF: ['off'],
};

export const languages = {
  ENGLISH: 'English',
  CODES: {
    ENGLISH: 'gb',
    GERMAN: 'de',
  },
};

export enum BurgerMenuRedirectPages {
  BOOKING = 'booking',
  BOOKING_OVERVIEW = 'booking-overview',
  GATEWAY_COMMISSIONING = 'gateway-commissioning',
  INSTALLATIONS = 'installation-overview',
  INVITATIONS = 'invitations',
  LEGAL_INFO = 'legal-info',
  SETTINGS = 'settings',
  UPDATES = 'updates',
  DEVICE_MONITORING = 'kanban-board',
}

export const fileExtensions = {
  PDF: 'pdf',
};

export const applicationRoles = {
  SUBSCRIPTIONS: 'CUAR_Vitoguide-CAN_MANAGE_SUBSCRIPTIONS',
  INVITATIONS: 'Vitoguide.Invitation',
};

export const iotRoles = {
  MAINTAINER: 'maintainer',
  SUPPORT_INTERNATIONAL: 'supportInternational',
  SUPPORT_INTERNATIONAL_DIAGNOSTIC: 'SupportInternationalWithRemoteDiagnosis',
};

export const monetizationFeatures = {
  DATA_TRENDING: 'DataRecorderAndDataTrending',
  DIAGNOSIS: 'ExtendedParameters',
  PERMANENT_INSPECTION: 'PermanentInspection',
  SYSTEM_OVERVIEW: 'SystemOverview',
};

export const gatewaySerialPrefixesE3 = [
  '7470042', // "TCU 300"
  '7782093', // "TCU 300"
  '7906781', // "TCU 300"
  '7724827', // "TCU 200"
  '7732096', // "TCU 200"
  '7736172', // "TCU 300 LAN"
  '7633301', // "TCU 200 NA"
  '7633107', // "TCU 100"
];

export const deviceRoles = {
  LEGACY: 'type:legacy',
  E3: 'type:E3',
};

export const rsaDashboard = {
  IDENTITY_TYPE: 'IdentityType',
  SECTIONS: {
    ERROR: 'Error',
    GATEWAY: 'Communication module',
    USER: 'User',
    VOUCHER: 'Activation codes',
  },
  USER_SECTION: {
    FIELDS: {
      USERNAME: 'username',
      FIRST_NAME: 'firstName',
      FAMILY_NAME: 'familyName',
    },
    SEARCH_DATA: {
      USERNAME: 'username',
      FULL_NAME: 'fullName',
    },
  },
};

export const browserKeys = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
};

export const installationTypes = {
  COMMERCIAL: 'Commercial',
  RESIDENTIAL: 'Residential',
};

export const stickyPanel = {
  LIMITED_LIST_MAX_LENGTH: 2,
};

export const USERS = {
  DEMO: 'demo',
  CEO_MAINTAINER: 'ceo_maintainer',
  INTERNATIONAL_SUPPORTER: 'internationalSupporter',
  INTERNATIONAL_SUPPORTER_WITH_DIAGNOSTICS: 'internationalSupporterDiagnostics',
  TEST_AUTOMATION: 'testAutomationUser',
};
